import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {QRCodeSVG} from "qrcode.react";
import {triggerConfetti} from '@/utils/animations.js';

// Résultat dédié aux joueurs "tirs au but seulement" (latecomer) : pas de cadre fin-de-match.
// WIN = lot péno gagné (clic → QR) ; LOSE = séance terminée + consolation éventuelle.
// status: 'WIN' | 'LOSE'. reward = lot péno gagné (WIN) ; consolationReward = lot de consolation (LOSE).
export const StepPenaltyResult = ({
                                      status,
                                      reward = null,
                                      consolationReward = null,
                                      rank = null,
                                      place,
                                      onShowQr = () => {},
                                      isPreview = false,
                                  }) => {
    const {t} = useTranslation();
    const isWin = status === 'WIN' && !!reward;
    const claimable = isWin ? reward : consolationReward;

    useEffect(() => {
        if (isWin && !isPreview) triggerConfetti();
    }, [isWin, isPreview]);

    return (
        <div className="mt-6 animate-fade-in bg-white rounded-3xl shadow-soft p-7 text-center">
            {/* Médaille / état */}
            <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center text-5xl
                ${isWin ? 'bg-action-green/15' : 'bg-slate-100'}`}>
                {isWin ? '🏆' : '⚽'}
            </div>

            <span className="inline-block bg-action-green/15 text-emerald-600 text-[11px] font-black uppercase tracking-widest px-3 py-1 rounded-full">
                {t('penalty.result.eyebrow', 'Tirs au but')}
            </span>

            <h2 className="text-2xl font-black text-gray-900 mt-3 leading-tight">
                {isWin
                    ? t('penalty.result.win_title', 'Tu remportes ton lot !')
                    : t('penalty.result.lose_title', 'Séance terminée !')}
            </h2>

            {rank != null && (
                <p className="text-sm text-gray-500 mt-2">
                    {t('penalty.result.rank_label', 'Rang')}{' '}
                    <span className="font-black text-gray-800">{t('penalty.result.rank_value', 'n°{{rank}}', {rank})}</span>{' '}
                    {t('penalty.result.rank_suffix', 'au classement des tirs au but')}.
                </p>
            )}

            {!isWin && (
                <p className="text-sm text-gray-500 leading-relaxed mt-2">
                    {t('penalty.result.lose_subtitle', 'Bien joué — merci d’avoir tenté les tirs au but !')}
                </p>
            )}

            {/* Lot (gagné ou consolation) : QR inline + bouton d'agrandissement — comme StepResult. */}
            {claimable && (
                <div className="mt-5">
                    <div className="bg-emerald-50 border border-emerald-100 rounded-2xl px-4 py-3 mb-3">
                        <div className="text-[10px] font-bold text-emerald-600 uppercase tracking-widest">
                            {isWin ? t('penalty.result.won_label', 'Ton lot') : t('penalty.result.consolation_label', 'Lot de consolation')}
                        </div>
                        <div className="text-lg font-black text-gray-900 mt-0.5">{claimable.title}</div>
                    </div>

                    {claimable.code && (
                        <>
                            {/* QR inline (encart pointillé identique à StepResult) */}
                            <div className="bg-yellow-50 border-2 border-dashed border-yellow-300 rounded-2xl p-4 mb-2 flex justify-center items-center">
                                <div className="w-32 h-32 bg-white p-2 rounded-lg shadow-inner">
                                    <QRCodeSVG
                                        value={claimable.code}
                                        width="100%"
                                        height="100%"
                                        level="L"
                                        marginSize={0}
                                        fgColor="#000000"
                                        bgColor="#ffffff"
                                    />
                                </div>
                            </div>
                            {/* Bouton = agrandir le QR plein écran (onShowQr), comme StepResult */}
                            <button
                                onClick={() => onShowQr({isOpen: true, title: claimable.title, url: claimable.code})}
                                className="w-full py-4 mt-2 bg-action-green text-white font-black rounded-xl hover:brightness-110 active:scale-98 transition-all"
                            >
                                {isPreview ? t('result.btn_present_counter') : t('result.btn_show_qr')}
                            </button>
                        </>
                    )}

                    {place?.name && (
                        <p className="text-[11px] text-gray-400 mt-3">
                            {t('penalty.result.redeem_at', 'À présenter au comptoir de')} <span className="font-bold text-gray-600">{place.name}</span>
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default StepPenaltyResult;
